import React, { useState } from "react";
import styled from "styled-components";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Home() {
  const [captchaValue, setCaptchaValue] = useState(null);
  let navigate = useNavigate();

  const onSubmitButton = () => {
    if (captchaValue) {
      navigate(`/budget/${captchaValue}`);
    } else {
      window.alert("Please fill the captcha.");
    }
  };

  return (
    Header && Footer && <Container>
      <MainSection>
        <Header isHome={true}/>
        <TitleSection>
          <h1>Budget</h1>
          <span>
            Make more intelligent hotel budgeting decisions with the
            industry-leading Budget from Bezla.
          </span>
        </TitleSection>
        <ButtonSection>
          <div>
            <ReCAPTCHA
              sitekey="6Ld_S8MdAAAAACAkzMl0Pfsc3eMUDGXWjv2C_lgT"
              onChange={(item) => setCaptchaValue(item)}
              onErrored={() => setCaptchaValue(null)}
            />
          </div>
          <Button onClick={() => onSubmitButton()} type="button" label="Launch" variant="secondary"/>
        </ButtonSection>
      </MainSection>
      <Footer />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin-top: 136px;
`;

const MainSection = styled.div`
  padding: 0 2rem;
  background-image: url(https://img1.wsimg.com/isteam/ip/23c01d94-28d3-425c-b0cf-5bb9e0b17e5f/Bezla.com%20LLC%20Hotel%20Marketing%20Company.png/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:1920,m);
  background-size: cover;
  height: 620px;
`;

const TitleSection = styled.section`
  color: white;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-top: 6rem;
  font-family: "Noto Sans", sans-serif;
  
  & > h1 {
    text-shadow: 2px 2px 2px rgb(0 0 0 / 10%);
    font-weight: 700;
    line-height: 1.3;
    font-size: 4.5rem;
  }

  & > span {
    text-shadow: 2px 2px 2px rgb(0 0 0 / 10%);
    font-size: 1.25rem;
    margin-top: 0;
    margin-bottom: 1rem;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    max-width: 600px;
    text-align: center;
  }
`;

const ButtonSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  margin-bottom: 10rem;
  & > button {
    min-width: 160px;
  }
`;
